import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {Observable} from 'rxjs/internal/Observable';

interface NotificationConfiguration {
  getSound$(): Observable<boolean>;

  setSound$(value: boolean): void;

  getToast$(): Observable<boolean>;

  setToast$(value: boolean): void;

  getVisible$(): Observable<boolean>;

  setVisible$(value: boolean): void;
}

@Injectable()
export class NotificationsConfigurationService implements NotificationConfiguration {
  private _sound$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private _toast$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private _visible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() {
  }

  getSound$(): Observable<boolean> {
    return this._sound$.asObservable();
  }

  getToast$(): Observable<boolean> {
    return this._toast$.asObservable();
  }

  getVisible$(): Observable<boolean> {
    return this._visible$.asObservable();
  }

  setSound$(value: boolean) {
    this._sound$.next(value);
  }

  setToast$(value: boolean) {
    this._toast$.next(value);
  }

  setVisible$(value: boolean) {
    this._visible$.next(value);
  }
}
